<template>
    <div>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>

                    <div class="row mb-2">
                        <div class="col-sm-12 col-md-12 mb-2">
                            <div class="dataTables_filter">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
                                        :placeholder="$t('label.search')" v-model="searchStock" @keyup.enter="filterSearchStock">
                                    <button
                                        class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search"
                                        @click="filterSearchStock">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4 mb-2">
                            <date-range-picker class="w-100"
                                :minDate="minDate"
                                ref="picker"
                                v-model="dateRange"
                                :opens="'right'"
                                :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                                :autoApply="true"
                                :showDropdowns="true"
                                :always-show-calendars="true"
                                :single-date-picker="true"
                                :ranges="false"
                                @showCustomRange="showCustomRangeCalendars = true"
                                @update="filterByDate">
                            </date-range-picker>
                        </div>
                        <div class="col-sm-12 col-md-4 mb-2">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-store"></i>
                                        </label>
                                        <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false"
                                            :show-labels="false" openDirection="below" @select="filterByOutlet"></multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4 mb-2">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0" for="serviceCategory">
                                            <i class="fas fa-tags"></i>
                                        </label>
                                        <multiselect
                                            :value="selectedSubcategory"
                                            :options="subCategoryFilter"
                                            track-by="folderID"
                                            label="name"
                                            :show-labels="false"
                                            openDirection="below"
                                            @select="filterBySubCategory">
                                            <span slot="noResult">
                                                {{ $t('table.no_records') }}
                                            </span>
                                            <template slot="option" slot-scope="{ option }">
                                                {{  option.name }}
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="link text-primary" @click="clearFilter()">{{ $t('button_link.clear_filter') }}</a>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" v-for="c in categoryFilter" :key="c.sectionID">
                                <a :class="{ 'active': selectedCategory == c.sectionID }" class="nav-link" role="tab" @click="filterByCategory(c.sectionID)">{{ c.name }}</a>
                            </li>
                        </ul>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                            {{ $t('table.no_records') }}
                        </div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div v-if="false" class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{ $t('table.pagination', { 'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries, }) }}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries"
                                        @input="handlePagination"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :items="stockBalanceItems" :sort-compare="sortTable" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(category)="data">
                                            {{ (data.item.section || {})['name'] || '' }}
                                        </template>
                                        <template #cell(folderID)="data">
                                            {{ (data.item.folder || {})['name'] || '-' }}
                                        </template>
                                        <template #cell(price)="data">
                                            {{ parseFloat((data.item.price || {})['price'] || 0).toFixed(2) }}
                                        </template>
                                        <template #cell(basePrice)="data">
                                            {{ parseFloat((data.item.price || {})['base'] || 0).toFixed(2) }}
                                        </template>
                                        <template #cell(balance)="data">
                                            {{ data.item.total || 0 }}
                                        </template>
                                        <template #cell(priceInventory)="data">
                                            {{ parseFloat(((data.item.price || {})['price'] || 0) * (data.item.total || 0)).toFixed(2) }}
                                        </template>
                                        <template #cell(costInventory)="data">
                                            {{ parseFloat(((data.item.price || {})['base'] || 0) * (data.item.total || 0)).toFixed(2) }}
                                        </template>
                                        <template #cell(action)="data">
                                            <button type="button" class="btn btn-xs btn-outline-primary waves-effect waves-themed mr-2"
                                                title="Stock In/Stock Out" @click="editStock(data.item)">
                                                +/-
                                            </button>
                                            <button type="button" class="btn btn-xs btn-outline-primary waves-effect waves-themed" title="View Inventory"
                                                @click="getInventory(data.item.skuID, data.item.name)">
                                                <i class="fal fa-inventory"></i>
                                            </button>
                                        </template>
                                        <!-- <template #custom-foot>
                                            <b-tr>
                                                <b-td class="border-top-bottom-2 text-right fw-700" colspan="4">{{ $t('table.header.subtotal') }}</b-td>
                                                <b-td class="border-top-bottom-2 fw-500">{{ stockBalanceSubTotal.price }}</b-td>
                                                <b-td class="border-top-bottom-2 fw-500">{{ stockBalanceSubTotal.cost }}</b-td>
                                                <b-td class="border-top-bottom-2 fw-500">{{ stockBalanceSubTotal.balance }}</b-td>
                                                <b-td class="border-top-bottom-2 fw-500">{{ stockBalanceSubTotal.priceInventory }}</b-td>
                                                <b-td class="border-top-bottom-2 fw-500">{{ stockBalanceSubTotal.costInventory }}</b-td>
                                                <b-td class="border-top-bottom-2 disabled-td"></b-td>
                                            </b-tr>
                                        </template> -->
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <stockInOut ref="stockInOut" @returnParent="returnStockBalance"></stockInOut>
    </div>
</template>

<script>
import StockInOut from './Stock_In_Out'
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'
import { setReturnData, getCategoryText, handleSessionExpired, setCategoryLabel, getSubcategory } from '@/assets/js/dashboard/dashboard.js'
import { convertTimestampToDateTime, convertDateToTimestamp } from '@/assets/js/dashboard/utilities.js'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

export default {
    name: 'stockBalance',
    components: {
        StockInOut, DateRangePicker
    },
    data() {
        let startDate = moment();
        return {
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            typeID: 2,

            isSpinnerShow: false,
            stockInOutToggleModal: false, stockTitle: "",
            startDate: '01/01/1990',
            dateRange: { startDate }, dateFilter: "",
            searchStock: "", searchStockFilter: "",
            
            outlet: [], selectedOutlet: {},
            category: [{ id: "all", text: this.$i18n.t('label.all', { 'item': this.$i18n.t('table.header.category') }) }],
            selectedTab: "all",
            subCategories: [], subCategory: [], selectedSubCategory: {},
            stockBalanceItems: [], stockBalanceSubTotal: {},
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "", stockExportData: [],

            stockBalanceMap: {},

            categoryCache: [],
            categoryMap: {},
            sectionMap: {},
            categoryFilter: [],

            subCategoryCache: [],
            subCategoryMap: {},
            folderMap: {},
            subCategoryFilter: [],
            
            selectedCategory: "all",
            selectedSubcategory: {},
        }
    },
    computed: {
        fields() {
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle' },
                { key: "name", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', sortable: true },
                { key: "category", label: this.$i18n.t('table.header.category'), thClass: 'thead-themed align-middle' },
                { key: "folderID", label: this.$i18n.t('table.header.subcategory'), thClass: 'thead-themed align-middle' },
                { key: "price", label: this.$i18n.t('table.header.price'), thClass: 'thead-themed align-middle', sortable: true },
                { key: "basePrice", label: this.$i18n.t('label.cost'), thClass: 'thead-themed align-middle', sortable: true },
                { key: "balance", label: this.$i18n.t('table.header.balance'), thClass: 'thead-themed align-middle', sortable: true },
                { key: "priceInventory", label: this.$i18n.t('salon_report.stock.price_inventory'), thClass: 'thead-themed align-middle', sortable: true },
                { key: "costInventory", label: this.$i18n.t('salon_report.stock.cost_inventory'), thClass: 'thead-themed align-middle', sortable: true },
                { key: "action", label: "", thClass: 'thead-themed align-middle' },
            ]
        },
        exportFields() {
            var ret = {}
            ret["#"] = "index"
            ret[this.$i18n.t('table.header.title').toUpperCase()] = "name"
            ret[this.$i18n.t('table.header.category').toUpperCase()] = "category"
            ret[this.$i18n.t('table.header.subcategory').toUpperCase()] = "subCategory"
            ret[this.$i18n.t('table.header.balance').toUpperCase()] = "balance"
            ret[this.$i18n.t('label.cost').toUpperCase()] = "cost"
            ret[this.$i18n.t('table.header.price').toUpperCase()] = "price"
            ret[this.$i18n.t('label.total').toUpperCase()] = "total"
            return ret
        },
    },
    watch: {
        "$i18n.locale"(val) {
            this.setLabel()
            var b = Object.assign({}, this.selectedSubCategory)
            this.selectedSubCategory = this.subCategory.filter(obj => obj.id == b.id)[0]

            this.setExportData(this.stockExportData)
        }
    },
    methods: {
        getCategoryText(id, category) {
            return getCategoryText(id, category);
        },
        getTotal(quantity, price) {
            return quantity * price;
        },
        getStockBalanceSubTotal(items) {
            var balance = 0; var price = 0; var cost = 0; var priceInventory = 0; var costInventory = 0;
            for (var i = 0; i < items.length; i++) {
                if ('total' in items[i]) {
                    balance += items[i].total
                    priceInventory += this.getTotal(items[i].total, (items[i].price || {})['price'] || 0)
                    costInventory += this.getTotal(items[i].total, (items[i].price || {})['base'] || 0)
                }
                price += (items[i].price || {})['price'] || 0
                cost += (items[i].price || {})['base'] || 0
            }

            return {
                balance: balance,
                price: parseFloat(price).toFixed(2),
                cost: parseFloat(cost).toFixed(2),
                priceInventory: parseFloat(priceInventory).toFixed(2),
                costInventory: parseFloat(costInventory).toFixed(2),
            }
        },
        sortTable(a, b, key) {
            if (key == "balance") {
                var aBalance = !("total" in a) ? 0 : a.total
                var bBalance = !("total" in b) ? 0 : b.total
                return aBalance - bBalance
            } else if (key == "costInventory") {
                var aCost = !("total" in a) ? 0 : parseFloat(this.getTotal(a.total, a.basePrice)).toFixed(2)
                var bCost = !("total" in b) ? 0 : parseFloat(this.getTotal(b.total, b.basePrice)).toFixed(2)
                return aCost - bCost
            } else if (key == "priceInventory") {
                var aPrice = !("total" in a) ? 0 : parseFloat(this.getTotal(a.total, a.price)).toFixed(2)
                var bPrice = !("total" in b) ? 0 : parseFloat(this.getTotal(b.total, b.price)).toFixed(2)
                return aPrice - bPrice
            }
            return false
        },

        async loadSection() {
            const url = "https://menu.tunai.io/business/sections?typeID=" + this.typeID

            await this.$axios.get(url, { headers: { token: this.$util.getSessionToken() } })
                .then((response) => {
                    var results = this.categoryCache = response.data.sections;

                    for(let item of results) {
                        if(item['categoryID'] !== -1) {
                            this.categoryMap[item['categoryID']] = item
                        }

                        this.sectionMap[item['sectionID']] = item
                    }

                    this.categoryFilter = [{sectionID: "all", name: 'All'}].concat(this.categoryCache)
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == "Invalid Token") {
                        handleSessionExpired();
                    }
                })
        },
        async loadFolder() {
            const url = "https://menu.tunai.io/business/folder?typeID=" + this.typeID
            // const url = "https://m5.tunai.io/business/setting/menu/folder?type=product"

            await this.$axios.get(url, { headers: { token: this.$util.getSessionToken() } })
                .then((response) => {
                    var results = this.subCategoryCache = response.data.folders;

                    for(let item of results) {
                        if(item['subcategoryID'] !== -1) {
                            this.subCategoryMap[item['subcategoryID']] = item
                        }

                        this.folderMap[item['folderID']] = item
                    }
                    
                    this.subCategoryFilter = [{folderID: "all", name: 'All Folders'}].concat(this.subCategoryCache)
                    this.selectedSubcategory = this.subCategoryFilter[0]
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == "Invalid Token") {
                        handleSessionExpired();
                    }
                })
        },

        filterSearchStock() {
            this.page = 0
            this.loadData()
        },
        filterByOutlet(item) {
            this.page = 0
            this.selectedOutlet = item;
            this.loadData()
        },
        filterByDate(date) {
            this.page = 0
            this.loadData()
        },
        async filterByCategory(item) {
            this.page = 0;
            this.selectedCategory = item;

            let selectedCategory = this.sectionMap[item] || {}

            let temp = []
            let subcategoryInSelection = false
            for(let item of this.subCategoryCache) {
                if(this.selectedCategory === 'all' || String(item['section']['sectionID']) === String(selectedCategory['sectionID'])) {
                    if(String(this.selectedSubcategory['folderID']) === String(item['folderID'])) {
                        subcategoryInSelection = true
                    }
                    temp.push(item)
                }
            }

            this.subCategoryFilter = [{folderID: "all", name: 'All Folders'}].concat(temp)
 
            if(!subcategoryInSelection) {
                this.selectedSubcategory = this.subCategoryFilter[0]
            }

            this.loadData()
        },
        filterBySubCategory(item) {
            this.page = 0
            this.selectedSubcategory = item;
            this.loadData()
        },
        clearFilter() {
            this.page = 0
            this.searchStock = "";
            this.selectedSubcategory = this.subCategoryFilter[0];
            this.selectedCategory = "all"
            this.dateRange = { startDate: moment()}
            this.loadData()
        },
        handlePagination(pg) {
            if (pg != null) {
                this.page = pg - 1;
                this.loadData()
                // this.setStockBalanceItems(this.dateFilter, this.categoryFilter + this.subCategoryFilter + this.searchStockFilter)
                //document.getElementById('btnToTop').click(); 
            }
        },

        async loadData() {
            this.isSpinnerShow = true;
            var stockBalanceItems = await this.getStockBalanceItem();
            var productItems = await this.getProductItem();

            this.stockBalanceMap = {}
            for(let item of stockBalanceItems) {
                this.stockBalanceMap[item['sku']['skuID']] = item
            }

            productItems.skus.forEach((e)=>{
                e['total'] = (this.stockBalanceMap[e['skuID']] || {})['total'] || 0
                return e
            })

            var retData = setReturnData(productItems.skus, productItems.total, this.page)
            this.stockBalanceItems = retData.result;
            this.totalEntries = retData.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;
            this.isSpinnerShow = false;

            this.stockBalanceSubTotal = this.getStockBalanceSubTotal(retData.result)
            this.$emit('updateStockBalanceSummaryBox', this.stockBalanceSubTotal)

            this.getExportData()
        },
        async getStockBalanceItem() {
            // let $vm = this;
            // const QUERY_STRING =  "?page=" + $vm.page + strFilter;
            // const url =  $vm.$api.OUTLET + "/" + $vm.selectedOutlet.id + $vm.$api.STOCK_BALANCE + QUERY_STRING;
            let url = `https://menu.tunai.io/business/stock/balance?1=1`;

            url += '&date=' + moment(this.dateRange.startDate).endOf('day').unix()

            if (this.selectedOutlet) {
                url += '&outletID=' + this.selectedOutlet.id
            }

            var result = []
            await this.$axios({
                method: 'get',
                url: url,
                baseURL: this.$axios.defaults.baseURL,
                headers: { token: this.$util.getSessionToken() }
            })
                .then((response) => {
                    result = response.data.trxns;
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
            return result
        },
        async getProductItem(skipPaging) {
            let $vm = this;
            let url ='https://menu.tunai.io/business/sku?typeID=2'

            if (this.selectedOutlet) {
                url += '&outletID=' + this.selectedOutlet.id
            }

            if (this.selectedCategory !== 'all') {
                url += '&sectionID=' + this.selectedCategory
            }

            if(this.selectedSubcategory && this.selectedSubcategory.folderID && this.selectedSubcategory.folderID !== 'all') {
                url += '&folderID=' + this.selectedSubcategory.folderID
            }

            if (this.searchStock) {
                url += '&search=' + this.searchStock
            }

            // if(!skipPaging) {
            //     url += '&page=' + this.page
            // }

            if(this.showDisabled) {
                url += '&enable=0'
            } else {
                url += '&enable=1'
            }

            var result = []
            await $vm.$axios({
                method: 'get',
                url: url,
                baseURL: $vm.$axios.defaults.baseURL,
                headers: { token: $vm.$session.get('token') }
            })
                .then(function (response) {
                    result = response.data;
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
            return result;
        },

        editStock(item) {
            var obj = {
                folderID: this.selectedSubCategory,
                items: item
            }
            this.$refs.stockInOut.stockInOut(this.selectedOutlet, obj);
        },
        returnStockBalance(subCategory) {
            this.stockInOutToggleModal = false;
            this.loadData()
            // this.filterSubCategory(subCategory);
            this.$emit('refreshStockList')
        },
        getInventory(id, title) {
            this.$emit('getInventory', id, title, this.selectedOutlet.id)
        },

        async getExportData() {
            var productItems = await this.getProductItem(true);

            productItems.skus.forEach((e)=>{
                e['total'] = (this.stockBalanceMap[e['skuID']] || {})['total'] || 0
                return e
            })
            
            this.stockExportData = productItems.skus
            this.setExportData(productItems.skus)
        },
        setExportData(data) {
            var exportData = []
            for (var i = 0; i < data.length; i++) {
                exportData.push({
                    index: i + 1,
                    name: data[i].name,
                    category: (data[i].section || {}).name || '',
                    subCategory: (data[i].folder || {}).name || '',
                    balance: data[i].total || 0,
                    cost: (data[i].total || 0) * ((data[i].price || {})['base'] || 0),
                    price: (data[i].price || {})['price'] || 0,
                    total: (data[i].total || 0) * ((data[i].price || {})['price'] || 0),
                })
            }

            console.log(exportData)

            this.exportData = exportData;
            var strDate = moment(this.dateRange.startDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_stock`) + " (" + this.$i18n.messages[this.$i18n.locale].tab.stockTabs[0].text + ")"
            this.exportHeaders = [
                header,
                this.$i18n.t('table.header.date') + ": " + strDate,
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),
                this.$i18n.t('label.outlet') + ": " + (this.selectedOutlet.id == "all" ? this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) : this.selectedOutlet.text),
                " "];
            this.exportFileName = header.split(" ").join("_") + strDate + this.$msg.REPORT.CSV
        },
        setLabel() {
            var category = JSON.parse(this.$store.state.category);
            this.category = setCategoryLabel(this, true, this.$i18n.t('label.all', { 'item': this.$i18n.t('label.category') }), category.product)
            this.subCategory = setCategoryLabel(this, false, this.$i18n.t('label.all', { 'item': this.$i18n.t('label.subcategory') }), this.subCategories)
        },
    },
    async mounted() {
        let $vm = this;
        $vm.dateFilter = "&startDate=" + $vm.startDate + "&endDate=" + moment($vm.dateRange.startDate).format(this.$msg.CST.DATE_FORMAT)

        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];

        // $vm.setStockBalanceItems($vm.dateFilter, "")

        $vm.subCategories = await getSubcategory($vm, 'product', "");
        $vm.setLabel()
        $vm.selectedSubCategory = $vm.subCategory[0]

        await this.loadSection()
        await this.loadFolder()
        await this.loadData()
    }
}
</script>
<style scoped>
.nav-link {
    cursor: pointer;
}

.show {
    display: block;
}

.modal-lg {
    max-width: 60vw;
}

.modal-body-lg {
    min-height: 60vh;
    max-height: 80vh;
    overflow-y: auto;
}

.border-top-bottom-2 {
    border-top-width: 2px !important;
    border-bottom-width: 2px !important;
}

.disabled-td {
    background: #e9e9e9;
}</style>